import React from "react";
import {
    resolveRoomLayout,
    RoomLayoutValue,
} from "../utils/RoomLayout";

export type {
    RoomLayoutValue,
    RoomOrientation,
} from "../utils/RoomLayout";

const RoomLayoutContext = React.createContext<RoomLayoutValue | null>(null);

export const RoomLayoutProvider = ({ children }: { children: React.ReactNode }) => {
    const [dimensions, setDimensions] = React.useState(() => ({
        width: window.innerWidth,
        height: window.innerHeight,
    }));

    React.useEffect(() => {
        const update = () => setDimensions({
            width: window.innerWidth,
            height: window.innerHeight,
        });

        window.addEventListener("resize", update);
        window.addEventListener("orientationchange", update);

        return () => {
            window.removeEventListener("resize", update);
            window.removeEventListener("orientationchange", update);
        };
    }, []);

    const value = React.useMemo(
        () => resolveRoomLayout(dimensions.width, dimensions.height),
        [dimensions.width, dimensions.height]
    );

    return (
        <RoomLayoutContext.Provider value={value}>
            {children}
        </RoomLayoutContext.Provider>
    );
};

export const useRoomLayout = () => {
    const value = React.useContext(RoomLayoutContext);

    if(!value) {
        throw new Error("useRoomLayout must be used within RoomLayoutProvider");
    }

    return value;
};
